import React from 'react';
import { isJpgImage } from '../../../../utils/imageHelpers';
import {
  ProductItem,
  ProductItemWrapper,
  ProductItemName,
} from './multiConfigStyles';
import { useSelector } from 'react-redux';
import MultiConfigProductItemCTA from './MultiConfigProductItemCTA';

const MultiConfigProductItem = ({ item, onClick }) => {
  const isPrepay = useSelector((state) => state.shoot.isPrepay);
  const { product, background, pose } = item;
  // Don't show background behind JPG poses - they don't have alpha transparency
  const isJpg = pose?.url && isJpgImage(pose.url);
  const backgroundOptionStyle =
    background && !isJpg
      ? {
          backgroundImage: `url(${background?.image_thumbnail})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      : {};

  const isConfigurable = isPrepay
    ? product.backgrounds_count > 0
    : product.poses_count > 0;

  return (
    <ProductItemWrapper>
      <ProductItem
        style={{
          ...backgroundOptionStyle,
          ...(isConfigurable ? {} : { cursor: 'unset' }),
        }}
        onClick={isConfigurable ? onClick(product) : null}
      >
        {pose ? (
          <img
            src={pose.url}
            onContextMenu={(e) => e.preventDefault()}
            alt="Overlay Pose"
          />
        ) : (
          !background &&
          product.image_thumbnail && (
            <img src={product.image_thumbnail} alt={product?.name} />
          )
        )}
        {isConfigurable && (
          <MultiConfigProductItemCTA item={item} onClick={onClick} />
        )}
      </ProductItem>
      <ProductItemName>{`${
        (isPrepay && background) || (pose && background) ? '✅ ' : ''
      }${product?.name}`}</ProductItemName>
    </ProductItemWrapper>
  );
};

export default MultiConfigProductItem;
